module.exports = __webpack_public_path__ + "media/images/ticket/coupon_title-d286e661fc0c352f6c1d63779fefc2af.png";